import * as React from "react";
import { useState } from "react";
import { useSpring, animated } from "react-spring";
import {
  getDetailedBarData,
  ResponsiveContainer,
} from "../../../libs/commission_calculator_dashboard";
import { BarChart } from "./BarChart";
import styled from "styled-components";
export const QuotaAverageTeamMemberBar = ({ data, collapsible = true }) => {
  const [isOpen, setIsOpen] = useState(false);
  const propsMain = useSpring({
    opacity: isOpen ? 1 : 0,
    height: isOpen ? "60px" : "0px",
    from: { opacity: isOpen ? 0 : 1, height: isOpen ? "0px" : "60px" },
  });
  const propsDetailed = useSpring({
    opacity: isOpen ? 1 : 0,
    height: isOpen ? "180px" : "0px",
    from: { opacity: isOpen ? 0 : 1, height: isOpen ? "0px" : "180px" },
  });
  const detailedBarData = getDetailedBarData(data, [
    "id",
    "name",
    "userId",
    "Quota Average",
  ]);
  if (collapsible) {
    return (
      <>
        <BarChartContainer
          onClick={() => setIsOpen(!isOpen)}
          style={{ cursor: "pointer" }}
        >
          {isOpen ? (
            <BarChartMainOuterOpenedContainer>
              <Divider />
              <BarChart
                key={data.id}
                data={[data]}
                keys={["Quota Average"]}
                indexBy={"name"}
                colorAttribute={"Quota Average"}
                title={data.name}
              />
            </BarChartMainOuterOpenedContainer>
          ) : (
            <BarChartMainOuterContainer>
              <BarChart
                key={data.id}
                data={[data]}
                keys={["Quota Average"]}
                indexBy={"name"}
                colorAttribute={"Quota Average"}
                title={`${data.name}'s Quota Average`}
              />
            </BarChartMainOuterContainer>
          )}
        </BarChartContainer>
        {isOpen && (
          <animated.div style={propsDetailed}>
            <BarChartDetailedOuterContainer>
              <BarChartDetailedContainer>
                <QuotaAverageTeamMemberDetailedBars data={detailedBarData} />
              </BarChartDetailedContainer>
            </BarChartDetailedOuterContainer>
            <Divider />
          </animated.div>
        )}
      </>
    );
  } else {
    return (
      <>
        <BarChartContainer>
          <BarChartMainOuterOpenedContainer>
            <BarChart
              key={data.id}
              data={[data]}
              keys={["Quota Average"]}
              indexBy={"name"}
              colorAttribute={"Quota Average"}
              title={`${data.name}'s Quota Average`}
            />
          </BarChartMainOuterOpenedContainer>
        </BarChartContainer>
        <BarChartDetailedOuterContainer>
          <BarChartDetailedContainer>
            <QuotaAverageTeamMemberDetailedBars data={detailedBarData} />
          </BarChartDetailedContainer>
        </BarChartDetailedOuterContainer>
      </>
    );
  }
};

const QuotaAverageTeamMemberDetailedBars = ({ data }) => {
  return data.map((data, index) => {
    return (
      <BarChartContainer key={index}>
        <BarChart
          data={[data]}
          keys={[Object.keys(data)[0]]}
          indexBy={"label"}
          colorAttribute={Object.keys(data)[0]}
          title={Object.keys(data)[0]}
        />
      </BarChartContainer>
    );
  });
};

const Divider = styled.div`
  height: 1px;
  background-color: grey;
  width: 100%;
`;

export const ChartContainer = styled(ResponsiveContainer)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const BarChartDetailedOuterContainer = styled(ResponsiveContainer)`
  display: flex;
  flex-direction: row;
`;

const BarChartContainer = styled(ChartContainer)`
  height: 60px;
`;

const BarChartMainOuterContainer = styled(ResponsiveContainer)`
  height: 60px;
  display: flex;
  flex-direction: row;
`;

const BarChartMainOuterOpenedContainer = styled.div`
  height: 60px;
  display: flex;
  flex-direction: column;
  background-color: #a9bcd0;
  width: 100%;
`;

export const BarChartDetailedContainer = styled.div`
  height: 180px;
  display: flex;
  flex-direction: column;
  background-color: #d8dbe2;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid white;
  width: 100%;
`;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/dashboard/QuotaAverageTeamMemberBar.tsx